import type { SVGProps } from "react";
export interface MessageQuestionIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function MessageQuestionIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: MessageQuestionIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 6c0-1.036-.84-1.875-1.875-1.875H5c-1.036 0-1.875.84-1.875 1.875v10c0 1.036.84 1.875 1.875 1.875h2c.62 0 1.125.504 1.125 1.125v1.77l3.534-2.25a4.13 4.13 0 0 1 2.215-.645H19c1.035 0 1.874-.84 1.875-1.875zm2.25 10A4.125 4.125 0 0 1 19 20.125h-5.126c-.268 0-.531.056-.773.166l-.233.128L9.14 22.79c-1.414.9-3.266-.115-3.266-1.791v-.873H5A4.125 4.125 0 0 1 .875 16V6A4.125 4.125 0 0 1 5 1.875h14A4.125 4.125 0 0 1 23.125 6z"
      />
      <path
        fill={color}
        d="M12.876 9.01V9a.883.883 0 0 0-.877-.875c-.448 0-.834.311-.93.606a1.125 1.125 0 0 1-2.138-.697C9.356 6.727 10.67 5.875 12 5.875A3.133 3.133 0 0 1 15.125 9v.01c0 1.398-.863 2.191-1.493 2.62a10 10 0 0 1-.529.327 1.125 1.125 0 0 1-2.23-.207v-.3c0-.497.28-.824.42-.964a2.4 2.4 0 0 1 .424-.322c.304-.189.404-.225.65-.393.369-.251.508-.453.508-.761Zm.499 5.99a1.376 1.376 0 0 1-2.742.14l-.007-.14.007-.141A1.374 1.374 0 0 1 12 13.626l.14.007c.694.07 1.235.655 1.235 1.367"
      />
    </svg>
  );
}
